import React, { Component } from 'react';
import { Provider } from "react-redux";
import store from './store';
import Main from './Main';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import JssProvider from 'react-jss/lib/JssProvider';
import { create } from 'jss';
import { jssPreset } from '@material-ui/core/styles';

// if (process.env.NODE_ENV !== 'production') {
//   global.config = {
//     "routingServiceUrl": process.env.REACT_APP_ROUTING_SERVICE_URL,
//     "trackingServiceUrl": process.env.REACT_APP_TRACKING_SERVICE_URL,
//     "facilitiesServiceUrl": process.env.REACT_APP_FACILITIES_SERVICE_URL,
//   }
// }

// Configure css injection order to easily override default Material Stylesheets
// https://material-ui.com/customization/css-in-js/#css-injection-order
const jss = create(jssPreset());
jss.options.insertionPoint = document.getElementById('jss-insertion-point');

const muiThemeConfig = {
  breakpointValues: {
    xs: 0,
    sm: 600,
    md: 1024,
    xl: 1920
  }
};

const theme = createMuiTheme({
    typography: {
        useNextVariants: true,
    },
    breakpoints: {
        values: muiThemeConfig.breakpointValues
    },
});

class Bootstrap extends Component {
  render() {
    return (
      <Provider store={store}>
      <JssProvider jss={jss}>
        <MuiThemeProvider theme={theme}>
          <Main/>
        </MuiThemeProvider>
      </JssProvider>
      </Provider>
    );
  }
}

export default Bootstrap;



// WEBPACK FOOTER //
// ./src/Bootstrap.js